






import { Component, Vue } from "vue-property-decorator";
import { DashboardGridCpt } from "./components";
import AppVue from "@/AppVue.vue";

@Component({
  components: {
    DashboardGridCpt,
  },
})
export default class DashboardView extends AppVue {}
